"use client";

import React, { useCallback, useEffect, useState } from "react";
import { usePathname } from "next/navigation";

type ScrollContextType = {
  scrollY: number;
  isStarted: boolean;
};

export const ScrollContext = React.createContext<ScrollContextType>({
  scrollY: 0,
  isStarted: true,
});

const ScrollObserver = ({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) => {
  const [scrollY, setScrollY] = useState<number>(0);
  const [isStarted, setIsStarted] = useState<boolean>(true);
  const pathname = usePathname();

  const handleScroll = useCallback(() => {
    if (isStarted) {
      setScrollY(0)
      window.scrollTo(0, 0);
    } else {
      setScrollY(window.scrollY);
    }
  }, [isStarted])

  const resetScroll = () => {
    setScrollY(0);
    setIsStarted(true);
  };

  useEffect(() => {
    resetScroll();
  }, [pathname]);

  useEffect(() => {
    const time = setTimeout(() => {
      setIsStarted(false);
    }, 1000);
    return () => clearTimeout(time);
  }, [pathname]);

  useEffect(() => {
    document.addEventListener("scroll", handleScroll);
    return () => document.removeEventListener("scroll", handleScroll);
  }, [handleScroll, isStarted]);

  return (
    <ScrollContext.Provider value={{ scrollY, isStarted }}>
      {children}
    </ScrollContext.Provider>
  );
};

export default ScrollObserver;